import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { DeliveryShipmentImportHelperContainerModel } from '../../../../../../../models';
import { ApiVisa } from '../../../shared/api-visa.model';

@Injectable({
    providedIn: 'root'
  })
  export class ShipmentImportHelperService extends BaseApiTemplateService<DeliveryShipmentImportHelperContainerModel> {

    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del-shipment/import-file-helpers/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del-shipment/import-file-helpers/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del-shipment/import-file-helpers/backoffice-ep';
      this.httpClient = http;
    }
  }